import { render } from "./data-signals-bcg.vue?vue&type=template&id=f4a0a270"
import script from "./data-signals-bcg.vue?vue&type=script&lang=js"
export * from "./data-signals-bcg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__